module.exports = __webpack_public_path__ + "static/case-study-1-c26f855a66d88d6d468eff46a1c793f4.png";